export default __webpack_public_path__ + "static/media/insta.a07a4534.svg";